import PageLayout from './Auth/PageLayout.tsx'
import { useOidc } from '@axa-fr/react-oidc'
import { Header } from './Auth/Header.tsx'
import { useEffect, useState } from 'react'
import { Footer } from './Auth/Footer.tsx'

const LandingPage = () => {
  const { isAuthenticated, login, logout } = useOidc()
  const [logoutRequested, setLogoutRequested] = useState(false)
  const handleLogout = () => {
    setLogoutRequested(true)
    logout('https://www.kbw.de')
  }

  // Prüfen ob user Rolle 'Intern' enthält
  // Prüfen ob user Rolle 'Intern' enthält
  useEffect(() => {

    if (!isAuthenticated && !logoutRequested) {
      const timeoutId = setTimeout(() => {
        login()
      }, 2000) // 1000 Millisekunden = 1 Sekunde

      // Cleanup function to clear the timeout if the component unmounts or dependencies change
      return () => clearTimeout(timeoutId)
    }

  }, [isAuthenticated, login])

  return (
    <>
      <div className={'nw-app'} id="app">
        <div className="nw-appHeader">
          <Header login={login} logout={handleLogout} isAuthenticated={isAuthenticated} />
        </div>
        <div className="nw-page">
          <div className={'nw-mainContent'}>
            {isAuthenticated ? (
              <>
                <PageLayout />
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
        <Footer />
      </div>
    </>
  )
}

export default LandingPage
